import { useBatchedPaginatedQuery } from '@/hooks/use-batched-paginated-query';
import { api } from '@/lib/api';
import { queryKeys } from '@/lib/query-keys';
import type { AuditEntry } from '@property/shared';

export function useAudits(opts: { viewPage: number; viewPageSize?: number }) {
  const viewPageSize = opts.viewPageSize ?? 20;
  return useBatchedPaginatedQuery<AuditEntry>(
    queryKeys.audits.all(),
    (fetchOpts) =>
      api.listAudits({ page: fetchOpts.page, limit: fetchOpts.limit }).then((res) => ({
        data: res.entries,
        pagination: {
          page: res.page,
          limit: res.limit,
          total: res.total,
          totalPages: Math.ceil(res.total / res.limit),
        },
      })),
    { viewPage: opts.viewPage, viewPageSize },
  );
}
